export default "__VITE_ASSET__C_3B6GWs__"